import { Alert, Button } from 'reactstrap';
import { getTranslationKey } from '../../../modules/utils';
import { CustomModal } from '../CustomModal';
import { useNewDesignBanner } from './hooks/useNewDesignBanner';
import { useBannerHeightVariable } from './hooks/useBannerHeightVariable';

const MORE_INFO_URL = 'https://scrappbook.de/meet-the-new-scrappbook-beta/';

export const NewDesignBanner = () => {
  const {
    isOpen,
    isNewDesign,
    isCheckingTemplates,
    warning,
    close,
    toggleDesign,
    confirmWarning,
    cancelWarning
  } = useNewDesignBanner();
  const heightRef = useBannerHeightVariable();

  const warningKey =
    warning === 'upload' ? 'newDesign.banner.uploadWarning' : 'newDesign.banner.switchBackWarning';

  return (
    <>
      <div ref={heightRef}>
        <Alert
          data-cy="newDesignBanner"
          className="mb-0 d-flex align-items-center flex-wrap"
          color="success"
          isOpen={isOpen}
          toggle={close}
          closeAriaLabel={getTranslationKey('newDesign.banner.close')}
        >
          <span className="mr-3">
            {getTranslationKey('newDesign.banner.text')}{' '}
            <a
              data-cy="newDesignBannerMoreInfo"
              className="alert-link"
              href={MORE_INFO_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getTranslationKey('newDesign.banner.moreInfo')}
            </a>
          </span>
          <Button
            data-cy="newDesignBannerToggle"
            color="success"
            size="sm"
            disabled={isCheckingTemplates}
            onClick={toggleDesign}
          >
            {getTranslationKey(
              isNewDesign ? 'newDesign.banner.switchToOld' : 'newDesign.banner.switchToNew'
            )}
          </Button>
        </Alert>
      </div>
      <CustomModal
        isOpen={warning !== null}
        onClose={cancelWarning}
        onSave={confirmWarning}
        title={getTranslationKey(`${warningKey}.title`)}
        saveLabel={getTranslationKey(`${warningKey}.confirm`)}
      >
        <p data-cy={`newDesignSwitchWarning-${warning}`} className="mb-0">
          {getTranslationKey(`${warningKey}.text`)}
        </p>
      </CustomModal>
    </>
  );
};

export default NewDesignBanner;
